var map = {
	"./air-nga-en/assets/badge-icon.png": 91975,
	"./ais-tai-en/assets/badge-icon.png": 33956,
	"./ais-tai-tha/assets/badge-icon.png": 97080,
	"./demo-arabic/assets/badge-icon.png": 79664,
	"./demo-et-en/assets/badge-icon.png": 12259,
	"./demo-romanian/assets/badge-icon.png": 70833,
	"./demo-um-en/assets/badge-icon.png": 66128,
	"./dtac-tai-en/assets/badge-icon.png": 97681,
	"./dtac-tai-tha/assets/badge-icon.png": 12831,
	"./ethiotel-et-amh/assets/badge-icon.png": 75701,
	"./ethiotel-et-en/assets/badge-icon.png": 56694,
	"./mtn-cg-fr/assets/badge-icon.png": 55389,
	"./mtn-ci-fr/assets/badge-icon.png": 85263,
	"./mtn-cmr-fr/assets/badge-icon.png": 67691,
	"./mtn-gha-en/assets/badge-icon.png": 53726,
	"./mtn-nga-en/assets/badge-icon.png": 96618,
	"./mtn-zam-en/assets/badge-icon.png": 80432,
	"./saf-ke-en/assets/badge-icon.png": 41339,
	"./saudi-uae-en/assets/badge-icon.png": 76224,
	"./tlk-za-en/assets/badge-icon.png": 15623,
	"./vc-za-en/assets/badge-icon.png": 58987
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 76549;